'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { cx } from '../../../internal/cx.js';
import { CheckGlyph, ChevronDownGlyph } from '../../../internal/icons.js';
import { useFieldControl } from '../form-field/index.js';
/**
 * Single-value select built on Radix Select: typeahead, arrow-key navigation,
 * and screen-reader semantics come from the primitive.
 *
 *   <Select value={v} onValueChange={setV}>
 *     <SelectTrigger placeholder="Choose a status" />
 *     <SelectContent>
 *       <SelectItem value="open">Open</SelectItem>
 *     </SelectContent>
 *   </Select>
 */
export const Select = SelectPrimitive.Root;
export const SelectGroup = SelectPrimitive.Group;
export const SelectValue = SelectPrimitive.Value;
export const SelectTrigger = forwardRef(function SelectTrigger({ placeholder, size = 'md', invalid, className, children, ...rest }, ref) {
    // `required` is not a valid attribute on the trigger <button>; aria-required carries the meaning.
    const { required: _required, ...props } = useFieldControl(rest, { invalid });
    return (_jsxs(SelectPrimitive.Trigger, { ref: ref, ...props, "data-size": size, className: cx('mn-input', 'mn-select', className), children: [children ?? _jsx(SelectPrimitive.Value, { placeholder: placeholder }), _jsx(SelectPrimitive.Icon, { className: "mn-select__icon", children: _jsx(ChevronDownGlyph, {}) })] }));
});
export const SelectContent = forwardRef(function SelectContent({ className, children, position = 'popper', sideOffset = 4, ...rest }, ref) {
    return (_jsx(SelectPrimitive.Portal, { children: _jsx(SelectPrimitive.Content, { ref: ref, position: position, sideOffset: sideOffset, ...rest, className: cx('mn-menu', 'mn-select__content', className), children: _jsx(SelectPrimitive.Viewport, { className: "mn-select__viewport", children: children }) }) }));
});
export const SelectItem = forwardRef(function SelectItem({ className, children, ...rest }, ref) {
    return (_jsxs(SelectPrimitive.Item, { ref: ref, ...rest, className: cx('mn-menu__item', className), children: [_jsx(SelectPrimitive.ItemText, { children: children }), _jsx(SelectPrimitive.ItemIndicator, { className: "mn-menu__indicator", children: _jsx(CheckGlyph, {}) })] }));
});
export const SelectLabel = forwardRef(function SelectLabel({ className, ...rest }, ref) {
    return _jsx(SelectPrimitive.Label, { ref: ref, ...rest, className: cx('mn-menu__label', className) });
});
export const SelectSeparator = forwardRef(function SelectSeparator({ className, ...rest }, ref) {
    return (_jsx(SelectPrimitive.Separator, { ref: ref, ...rest, className: cx('mn-menu__separator', className) }));
});
//# sourceMappingURL=select.js.map